export const assetDetailPath = (assetId: string) => `/main/assets/${assetId}`;
